import $ from 'jquery';
export var initialPictureBG = function initialPictureBG() {
  $('.promo-bg, .pinned-image-bg').each(function (index, el) {
    var imgSource = $(el).attr('data-source') ? $(el).attr('data-source') : $(el).attr('src');
    $(el).css({
      'background-image': "url(".concat(imgSource, ")")
    });
  });
};
export default (function () {
  initialPictureBG();
});